import { FEATURE_FLAGS, useFeatureFlags } from "../../services/feature-flags/feature-flags";

/**
 * Reactive selector for React render paths.
 */
export function useTimelapseEnabled(): boolean {
  const { getBooleanFlag: getBooleanFlagFromStore } = useFeatureFlags();
  return getBooleanFlagFromStore(FEATURE_FLAGS.TIMELAPSE_USERS);
}
